import defaultValues from '../lib/defaultValues.js'

const state = {
  propertyType: defaultValues.propertyType,
  bathNumber: defaultValues.bathNumber,
  bedNumber: defaultValues.bedNumber,
  listingStatus: defaultValues.listingStatus,
  listingOptions: defaultValues.listingOptions,
  listingEvents: defaultValues.listingEvents,
  minSqft: defaultValues.minSqft,
  maxSqft: defaultValues.maxSqft,
  minLotSize: defaultValues.minLotSize,
  maxLotSize: defaultValues.maxLotSize,
  minPrice: defaultValues.minPrice,
  maxPrice: defaultValues.maxPrice,
  minHOA: defaultValues.minHOA,
  maxHOA: defaultValues.maxHOA,
  insideFeatures: defaultValues.insideFeatures,
  outsideFeatures: defaultValues.outsideFeatures,
  heatingCooling: defaultValues.heatingCooling,
  garage: defaultValues.garage,
  parking: defaultValues.parking,
  minHomeAge: defaultValues.minHomeAge,
  maxHomeAge: defaultValues.maxHomeAge,
  lotView: defaultValues.lotView,
  communityAmenities: defaultValues.communityAmenities,
  stories: defaultValues.stories,
  lastNonEmptyQuery: defaultValues.lastNonEmptyQuery,
  showWindow: defaultValues.showWindow
}

const getters = {
  getPropertyType: (state) => {
    return state.propertyType
  },
  getBathNumber: (state) => {
    return state.bathNumber
  },
  getBedNumber: (state) => {
    return state.bedNumber
  },
  getListingStatus: (state) => {
    return state.listingStatus
  },
  getListingOptions: (state) => {
    return state.listingOptions
  },
  getListingEvents: (state) => {
    return state.listingEvents
  },
  getMinSqft: (state) => {
    return state.minSqft
  },
  getMaxSqft: (state) => {
    return state.maxSqft
  },
  getMinLotSize: (state) => {
    return state.minLotSize
  },
  getMaxLotSize: (state) => {
    return state.maxLotSize
  },
  getMinPrice: (state) => {
    return state.minPrice
  },
  getMaxPrice: (state) => {
    return state.maxPrice
  },
  getMinHOA: (state) => {
    return state.minHOA
  },
  getMaxHOA: (state) => {
    return state.maxHOA
  },
  getInsideFeatures: (state) => {
    return state.insideFeatures
  },
  getOutsideFeatures: (state) => {
    return state.outsideFeatures
  },
  getHeatingCooling: (state) => {
    return state.heatingCooling
  },
  getGarage: (state) => {
    return state.garage
  },
  getParking: (state) => {
    return state.parking
  },
  getMinHomeAge: (state) => {
    return state.minHomeAge
  },
  getMaxHomeAge: (state) => {
    return state.maxHomeAge
  },
  getLotView: (state) => {
    return state.lotView
  },
  getCommunityAmenities: (state) => {
    return state.communityAmenities
  },
  getStories: (state) => {
    return state.stories
  },
  getLastNonEmptyQuery: (state) => {
    return state.lastNonEmptyQuery
  },
  getShowWindow: (state) => {
    return state.showWindow
  }
}

const mutations = {
  updatePropertyType: (state, propertyType) => {
    state.propertyType = propertyType
  },
  updateBathNumber: (state, bathNumber) => {
    state.bathNumber = bathNumber
  },
  updateBedNumber: (state, bedNumber) => {
    state.bedNumber = bedNumber
  },
  updateListingStatus: (state, listingStatus) => {
    if (typeof (listingStatus) === 'string') listingStatus = [listingStatus]
    state.listingStatus = listingStatus
  },
  updateListingOptions: (state, listingOptions) => {
    if (typeof (listingOptions) === 'string') listingOptions = [listingOptions]
    state.listingOptions = listingOptions
  },
  updateListingEvents: (state, listingEvents) => {
    if (typeof (listingEvents) === 'string') listingEvents = [listingEvents]
    state.listingEvents = listingEvents
  },
  updateMinSqft: (state, minSqft) => {
    state.minSqft = minSqft
  },
  updateMaxSqft: (state, maxSqft) => {
    state.maxSqft = maxSqft
  },
  updateMinLotSize: (state, minLotSize) => {
    state.minLotSize = minLotSize
  },
  updateMaxLotSize: (state, maxLotSize) => {
    state.maxLotSize = maxLotSize
  },
  updateMinPrice: (state, minPrice) => {
    state.minPrice = minPrice
  },
  updateMaxPrice: (state, maxPrice) => {
    state.maxPrice = maxPrice
  },
  updateMinHOA: (state, minHOA) => {
    state.minHOA = minHOA
  },
  updateMaxHOA: (state, maxHOA) => {
    state.maxHOA = maxHOA
  },
  updateInsideFeatures: (state, insideFeatures) => {
    if (typeof (insideFeatures) === 'string') insideFeatures = [insideFeatures]
    state.insideFeatures = insideFeatures
  },
  updateOutsideFeatures: (state, outsideFeatures) => {
    if (typeof (outsideFeatures) === 'string') outsideFeatures = [outsideFeatures]
    state.outsideFeatures = outsideFeatures
  },
  updateHeatingCooling: (state, heatingCooling) => {
    if (typeof (heatingCooling) === 'string') heatingCooling = [heatingCooling]
    state.heatingCooling = heatingCooling
  },
  updateGarage: (state, garage) => {
    state.garage = garage
  },
  updateParking: (state, parking) => {
    if (typeof (parking) === 'string') parking = [parking]
    state.parking = parking
  },
  updateMinHomeAge: (state, minHomeAge) => {
    state.minHomeAge = minHomeAge
  },
  updateMaxHomeAge: (state, maxHomeAge) => {
    state.maxHomeAge = maxHomeAge
  },
  updateLotView: (state, lotView) => {
    if (typeof (lotView) === 'string') lotView = [lotView]
    state.lotView = lotView
  },
  updateCommunityAmenities: (state, communityAmenities) => {
    if (typeof (communityAmenities) === 'string') communityAmenities = [communityAmenities]
    state.communityAmenities = communityAmenities
  },
  updateStories: (state, stories) => {
    state.stories = stories
  },
  updateLastNonEmptyQuery: (state, lastNonEmptyQuery) => {
    var queryClone = JSON.parse(JSON.stringify(lastNonEmptyQuery))
    state.lastNonEmptyQuery = queryClone
  },
  updateShowWindow: (state, showWindow) => {
    state.showWindow = showWindow
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/homeSearch.js